import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/animal-debt/details-back.webp";

function Developmentdetailsanimal() {
  return (
    <section className="development-details-animal p-100">
      <Container>
        <div
          className="development-main"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Row className="mb-4 mb-md-5">
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="text-center"
            >
              <h2 style={{ color: "#202020" }}>
                <span style={{ color: "#00806F" }}>Development</span> Details
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
              <div className="development-box">
                <h5 style={{ color: "#202020" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    fill="none"
                    viewBox="0 0 42 42"
                  >
                    <path
                      fill="#00806F"
                      d="M18.415 26.335c-.3-.023-.58-.163-.78-.39l-4.679-4.679a1.17 1.17 0 0 1 1.56-1.56l3.852 3.853 13.304-13.21a1.17 1.17 0 0 1 1.56 1.56L19.195 25.944a1.15 1.15 0 0 1-.78.39"
                    ></path>
                    <path
                      fill="#00806F"
                      d="M20.754 35.304A14.04 14.04 0 0 1 8.48 28.036a13.6 13.6 0 0 1-1.669-5.318 14.04 14.04 0 0 1 7.175-13.74 13.6 13.6 0 0 1 5.318-1.67 13.9 13.9 0 0 1 5.537.531 1.17 1.17 0 1 1-.671 2.23 11.9 11.9 0 0 0-4.679-.436c-1.555.158-3.062.63-4.43 1.388a11.7 11.7 0 0 0-3.43 2.87 11.57 11.57 0 0 0-2.558 8.593 11.5 11.5 0 0 0 1.388 4.43 11.7 11.7 0 0 0 2.87 3.43 11.57 11.57 0 0 0 8.593 2.558 11.5 11.5 0 0 0 4.43-1.388 11.7 11.7 0 0 0 3.43-2.87 11.57 11.57 0 0 0 2.559-8.593 1.23 1.23 0 0 1 2.448-.234 14.04 14.04 0 0 1-7.19 13.74 13.6 13.6 0 0 1-5.396 1.747z"
                    ></path>
                  </svg>
                  Platform
                </h5>
                <p>Unity (2D)</p>
              </div>
              <div className="development-box">
                <h5 style={{ color: "#202020" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    fill="none"
                    viewBox="0 0 42 42"
                  >
                    <path
                      fill="#00806F"
                      d="M18.415 26.335c-.3-.023-.58-.163-.78-.39l-4.679-4.679a1.17 1.17 0 0 1 1.56-1.56l3.852 3.853 13.304-13.21a1.17 1.17 0 0 1 1.56 1.56L19.195 25.944a1.15 1.15 0 0 1-.78.39"
                    ></path>
                    <path
                      fill="#00806F"
                      d="M20.754 35.304A14.04 14.04 0 0 1 8.48 28.036a13.6 13.6 0 0 1-1.669-5.318 14.04 14.04 0 0 1 7.175-13.74 13.6 13.6 0 0 1 5.318-1.67 13.9 13.9 0 0 1 5.537.531 1.17 1.17 0 1 1-.671 2.23 11.9 11.9 0 0 0-4.679-.436c-1.555.158-3.062.63-4.43 1.388a11.7 11.7 0 0 0-3.43 2.87 11.57 11.57 0 0 0-2.558 8.593 11.5 11.5 0 0 0 1.388 4.43 11.7 11.7 0 0 0 2.87 3.43 11.57 11.57 0 0 0 8.593 2.558 11.5 11.5 0 0 0 4.43-1.388 11.7 11.7 0 0 0 3.43-2.87 11.57 11.57 0 0 0 2.559-8.593 1.23 1.23 0 0 1 2.448-.234 14.04 14.04 0 0 1-7.19 13.74 13.6 13.6 0 0 1-5.396 1.747z"
                    ></path>
                  </svg>
                  Art Style
                </h5>
                <p>Hand-crafted illustrations created in Adobe Photoshop</p>
              </div>
              <div className="development-box">
                <h5 style={{ color: "#202020" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    fill="none"
                    viewBox="0 0 42 42"
                  >
                    <path
                      fill="#00806F"
                      d="M18.415 26.335c-.3-.023-.58-.163-.78-.39l-4.679-4.679a1.17 1.17 0 0 1 1.56-1.56l3.852 3.853 13.304-13.21a1.17 1.17 0 0 1 1.56 1.56L19.195 25.944a1.15 1.15 0 0 1-.78.39"
                    ></path>
                    <path
                      fill="#00806F"
                      d="M20.754 35.304A14.04 14.04 0 0 1 8.48 28.036a13.6 13.6 0 0 1-1.669-5.318 14.04 14.04 0 0 1 7.175-13.74 13.6 13.6 0 0 1 5.318-1.67 13.9 13.9 0 0 1 5.537.531 1.17 1.17 0 1 1-.671 2.23 11.9 11.9 0 0 0-4.679-.436c-1.555.158-3.062.63-4.43 1.388a11.7 11.7 0 0 0-3.43 2.87 11.57 11.57 0 0 0-2.558 8.593 11.5 11.5 0 0 0 1.388 4.43 11.7 11.7 0 0 0 2.87 3.43 11.57 11.57 0 0 0 8.593 2.558 11.5 11.5 0 0 0 4.43-1.388 11.7 11.7 0 0 0 3.43-2.87 11.57 11.57 0 0 0 2.559-8.593 1.23 1.23 0 0 1 2.448-.234 14.04 14.04 0 0 1-7.19 13.74 13.6 13.6 0 0 1-5.396 1.747z"
                    ></path>
                  </svg>
                  Monetization
                </h5>
                <p>
                  In-App Purchases for customization items and optional gameplay
                  boosts
                </p>
                <p>Rewarded Ads to unlock hints or special tools</p>
              </div>
              <p>
                All monetization is player-friendly, keeping the fun at the
                forefront
              </p>
              <div className="img">
                <StaticImage
                  src="../../../images/case-studies/animal-debt/Development-Details-2.webp"
                  alt="TekRevol"
                  layout="constrained"
                  className="mb-4"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={364}
                  height={69}
                />
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="text-center">
              <StaticImage
                src="../../../images/case-studies/animal-debt/Development-Details-1.webp"
                alt="TekRevol"
                layout="constrained"
                className="development-img-right"
                placeholder="blurred"
                formats={["webp"]}
                width={465}
                height={596}
              />
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Developmentdetailsanimal;
